import styled from "styled-components";
import { SPACING } from "../../utils/constants";
import { DisclosurePanel, DisclosureToggle } from "../Disclosure/styles";

export const HelperToggle = styled(DisclosureToggle)`
  display: block;
  margin-top: ${SPACING.xs}px;
  padding: ${SPACING.xs}px 0;
`;

export const HelperFields = styled(DisclosurePanel)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: ${SPACING.xs}px;
`;

export const HelperField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
`;

export const HelperLabel = styled.label`
  font-size: var(--text-xs);
  font-weight: 600;
  color: var(--color-text-secondary);
`;

export const HelperActions = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
`;
